module.exports = __webpack_public_path__ + "static/media/level_complete.b084041f.png";